import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paymentOfferLabel'
})
export class PaymentOfferLabelPipe implements PipeTransform {

  transform(value: any): string {
    switch (value) {
      case "7":
        return 'UPI Payment Offer';
      case "2":
        return 'Credit Card Payment Offer';
      default:
        return 'Other Payment Offer';
    }
  }

}
